<div [ngClass]="headerSticky ? 'theme-main-menu sticky-menu theme-menu-one fixed'
: 'theme-main-menu sticky-menu theme-menu-one'">
  <div class="d-flex align-items-center justify-content-center">
    <div class="">
      <a [routerLink]="['/']">
        
        <div class="header_wrap">
        <img class="smc_logo" *ngIf="env.environmentName == 'srinagar' || env.environmentName == 'swm-test' ; else second" src="assets/images/logo/{{env.loginLogo}}" alt="">
        <ng-template #second>
            <img class="env_logo"src="assets/images/logo/{{env.loginLogo}}" alt="">
            <h3 class="env_heading">Bhagalpur Municipal Corporation</h3>
        </ng-template>
      </div>
      </a>
    </div>
  </div>
</div>